import axios from 'utils/axios';

// eslint-disable-next-line no-unused-vars
export async function getCarePlanMeta(patientId, carePlanId) {
    try {
        const response = await axios.get(`/api/org-id/{orgId}/clinic-id/{clinicId}/patient/${patientId}/care-plan/${carePlanId}/meta`);
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}

export async function getCarePlanList(patientId) {
    try {
        const response = await axios.get(`/api/org-id/{orgId}/clinic-id/{clinicId}/patient/${patientId}/care-plan/list`);

        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}

export async function createCarePlan(patientId) {
    try {
        const response = await axios.post(`/api/org-id/{orgId}/clinic-id/{clinicId}/patient/${patientId}/care-plan/new`);

        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}

export async function getCarePlanContent(patientId, carePlanId, stepName) {
    try {
        const response = await axios.get(
            `/api/org-id/{orgId}/clinic-id/{clinicId}/patient/${patientId}/care-plan/${carePlanId}/content/${stepName}`
        );

        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}

export async function postCarePlanContent(patientId, carePlanId, stepName, data) {
    try {
        const response = await axios.post(
            `/api/org-id/{orgId}/clinic-id/{clinicId}/patient/${patientId}/care-plan/${carePlanId}/content/${stepName}`,
            data
        );

        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}

// SYN-376: attested is the pharmacist's review attestation from the summary
// step. The server only accepts true and records who/when on the care plan
export async function postFinalizeCarePlan(patientId, carePlanId, { attested }) {
    try {
        const response = await axios.post(
            `/api/org-id/{orgId}/clinic-id/{clinicId}/patient/${patientId}/care-plan/${carePlanId}/finalize`,
            {
                attested
            }
        );
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}

export async function postDuplicateCarePlan(patientId, carePlanId) {
    try {
        const response = await axios.post(
            `/api/org-id/{orgId}/clinic-id/{clinicId}/patient/${patientId}/care-plan/${carePlanId}/duplicate`
        );
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}

export async function getCarePlanSummary(patientId, carePlanId) {
    try {
        const response = await axios.get(`/api/org-id/{orgId}/clinic-id/{clinicId}/patient/${patientId}/care-plan/${carePlanId}/summary`);
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}

// discardEdits must be sent explicitly: the server refuses to regenerate over
// a saved edit unless the client confirms the discard
export async function postGenerateCarePlanSummary(patientId, carePlanId, discardEdits = false) {
    try {
        const response = await axios.post(
            `/api/org-id/{orgId}/clinic-id/{clinicId}/patient/${patientId}/care-plan/${carePlanId}/summary/generate`,
            { discardEdits }
        );
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}

export async function putCarePlanSummary(patientId, carePlanId, text) {
    try {
        const response = await axios.put(`/api/org-id/{orgId}/clinic-id/{clinicId}/patient/${patientId}/care-plan/${carePlanId}/summary`, {
            text
        });
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}

export async function generateCarePlanContent(patientId, carePlanId, type, diagnosisCode) {
    try {
        const body = { type };
        if (diagnosisCode) {
            body.diagnosisCode = diagnosisCode;
        }
        const response = await axios.post(
            `/api/org-id/{orgId}/clinic-id/{clinicId}/patient/${patientId}/care-plan/${carePlanId}/generate-content`,
            body
        );
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}
